<template>
  <div>
    <synoptic-filter page="dashboard" type="bubble" :select-devices="false"></synoptic-filter>
    <div class="monitor">
      <div class="container statbox-container">
        <dashboard v-if="dashboard" :dashboard="dashboard"></dashboard>
      </div>
    </div>

    <overlay :enabled="loading"></overlay>
  </div>
</template>

<script>
  import SynopticFilter from '@/layouts/Synoptic/Filter.vue'
  import Dashboard from '@/components/Dashboard.vue'
  import notificator from '../mixins/notificator';
  import { mapGetters } from 'vuex'

  import Overlay from '@/components/Overlay.vue';

  export default {
    name: 'monitor',

    components: {SynopticFilter, Dashboard, Overlay},

    mixins: [notificator],

    data() {
      return {
        dashboard: null,
        loading: false
      }
    },
    
    created() {
      if(this.selectedDashboard != null)
          this.getDashboardConfig();
    },

    computed: {    
      ...mapGetters([
        'selectedDashboard',
        'selectedSite'
      ])
    },
      
    watch: {
      selectedDashboard() {
        if(this.selectedDashboard != null) {
          this.dashboard = null;
          this.getDashboardConfig();
        }
      },

      selectedSite() {
          this.dashboard = null;        
      }
    },

    methods: {
      getDashboardConfig() {

        this.overlay(true);

        this.$store
          .dispatch('getDashboardConfig', {generalDashboard: false})
          .catch(error => {
            this.overlay(false);
            this.notify(this.$options.filters.notification({endpoint: 'GetDashboardConfig', code: error}));            
          })
          .then(({data}) => {
            this.overlay(false);

            /*
            if (error.response.data.mispErrorDTO.code != undefined)
              reject(error.response.data.mispErrorDTO.code);
            else
              reject(null);
            */
            this.notify(this.$options.filters.notification({endpoint: 'GetDashboardConfig', code: 200}));

            this.dashboard = data;
            
        });          
      },

      overlay(action) {
        this.loading = action;
      },  
    }      
  }
</script>
